// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BillboardFilters_wrapper__K6RMW","noLabel":"BillboardFilters_noLabel__c0P8k","label":"BillboardFilters_label__tE8jN","cinemas":"BillboardFilters_cinemas__x0Sb6"};